const madmaxPath = 'framework/';
const gamePath = '';

const gameset = {
    "stageWidth": 1280,
    "stageHeight": 720,
    "loadGraphics": "c",
    "preferGraphics": "h",
    "amaTitle": "Ultimate Crystals",
    "gameName": "Ultimate Crystals",
    "mute": false,
    "gameType": "reel",
    "currency": "cents",
    "game_id": "ultimate_crystals",
    "casino_id": 0,
    "uxtype": "mobile",
    "gameSign": "Ultimate Crystals",
    "version": "h",
    "language": "en",
    "lineGameType": "normal", //"normal", "lines", "levels"

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
    ],

    infoPages: {
        separated: true
    },

    "preloader": {},
    "system": {
        "audio" : {
            "tracks": [
                {
                    "name": "ui_Btn_Generic",
                    "url":  madmaxPath + 'assets/audio/ui_Btn_Generic.{ogg,mp3}',
                    "classVol": "volume.buttonEffect"
                },
                {
                    "name": "ui_Btn_Up",
                    "classVol": "volume.buttonEffect",
                    "reference": "ui_Btn_Generic"
                },
                {
                    "name": "ui_Btn_Down",
                    "classVol": "volume.buttonEffect",
                    "reference": "ui_Btn_Generic"
                },
                {
                    "name": "ui_Counter",
                    "url": `${madmaxPath}assets/audio/ui_Counter.{ogg,mp3}`,
                    "classVol": "volume.winCounter",
                    "loop": true
                },
                {
                    "name": "ui_Counter_Stop",
                    "url": `${madmaxPath}assets/audio/ui_Counter_Stop.{ogg,mp3}`,
                    "classVol": "volume.winCounter"
                },
                {
                    "name": "button_click",
                    "reference": "ui_Btn_Generic"
                },
                {
                    name: 'Jackpot_sound',
                    classVol: 'volume.normalWin',
                    "url": `assets/JokerWinBanner/Jackpot_sound.{ogg,mp3}`,
                    loop: false,
                },
                {
                    name: 'JokerBonus_alert',
                    classVol: 'volume.normalWin',
                    "url": `assets/JokerWinBanner/JokerBonus_alert.{ogg,mp3}`,
                    loop: false,
                },
            ]
        }
    },
    "game": {
        "basic": {
            "symbolsCount": 8,
            "slotsRows": 3,
            "slotsColumns": 5,
            "pilarsCount": 5
        },
        "webfonts": ["winlines","UbuntuMono-Regular", "Audiowide-Regular"],
        "layers": [
            "background",
            {
                "name": "winLines",
                "layers": [
                    "normal",
                    "idle"
                ]
            },
            "reels",
            "black",
            "idleAnim",
			"preloader",
            "dynamicText",
            "winLineNumbers",
            {
                "name": "win",
                "layers": [
                    "beam",
                    "wild",
                    "anim",
                    "particles",
                    "numbers"
                ]
            },
            {
                "name": "idleWin",
                "layers": [
                    "numbers",
                    "symbols",
                    "text"
                ]
            },
            "counter",
            {
                "name": "info",
                "layers": [
                    "bg",
                    "pageOne",
                    "pageTwo",
                    "pageThree",
                    "arrow"
                ]
            },
            "touchZone",
            "winFactors",
            "bigWin",
            "emitter",
            "logo"
		],
        "subLayers": [
        ],

        "audio": {
            "tracks": [
                {
                    "name": "bg_Music",
                    "url": `${gamePath}assets/audio/bg_Music.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "background.background"
                },
                {
                    "name": "bonus_Wild",
                    "url": `${gamePath}assets/audio/bonus_Wild.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds5"
                },
                {
                    "name": "bonus_Wild_End",
                    "url": `${gamePath}assets/audio/bonus_Wild_End.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds5"
                },
                {
                    "name": "bonus_Wild_Spin",
                    "url": `${gamePath}assets/audio/bonus_Wild_Spin.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds5"
                },
                {
                    "name": "bonus_Wild_Start",
                    "url": `${gamePath}assets/audio/bonus_Wild_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds4"
                },
                {
                    "name": "bwin_Bed",
                    "url": `${gamePath}assets/audio/bwin_Bed.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "miscSounds.miscSounds2"
                },
                {
                    "name": "bwin_Counter",
                    "url": `${gamePath}assets/audio/bwin_Counter.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Counter_Stop",
                    "url": `${gamePath}assets/audio/bwin_Counter_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_End",
                    "url": `${gamePath}assets/audio/bwin_End.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds1"
                },
                {
                    "name": "bwin_MegaWin",
                    "url": `${gamePath}assets/audio/bwin_MegaWin.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds3"
                },
                {
                    "name": "bwin_Start",
                    "url": `${gamePath}assets/audio/bwin_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds1"
                },
                {
                    "name": "bwin_SuperMegaWin",
                    "url": `${gamePath}assets/audio/bwin_SuperMegaWin.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds3"
                },
                {
                    "name": "reel_Start",
                    "url": `${gamePath}assets/audio/reel_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.startReel"
                },
                {
                    "name": "reel_Start_Wild",
                    "url": `${gamePath}assets/audio/reel_Start_Wild.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds5"
                },
                {
                    "name": "reel_Stop",
                    "url": `${gamePath}assets/audio/reel_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.stopReel"
                },
                {
                    "name": "ui_Btn_WinFactors",
                    "url": `${gamePath}assets/audio/ui_Btn_WinFactors.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.buttonEffect"
                },
                {
                    "name": "win_Beam_LR_01",
                    "url": `${gamePath}assets/audio/win_Beam_LR_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Beam_LR_02",
                    "url": `${gamePath}assets/audio/win_Beam_LR_02.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Beam_LR_03",
                    "url": `${gamePath}assets/audio/win_Beam_LR_03.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Beam_RL_01",
                    "url": `${gamePath}assets/audio/win_Beam_RL_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Beam_RL_02",
                    "url": `${gamePath}assets/audio/win_Beam_RL_02.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Beam_RL_03",
                    "url": `${gamePath}assets/audio/win_Beam_RL_03.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_Combo_01",
                    "url": `${gamePath}assets/audio/win_Combo_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.normalWin"
                },
                {
                    "name": "win_Combo_02",
                    "url": `${gamePath}assets/audio/win_Combo_02.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.normalWin"
                },
                {
                    "name": "win_Combo_03",
                    "url": `${gamePath}assets/audio/win_Combo_03.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.normalWin"
                },
                {
                    "name": "win_IdleWin",
                    "url": `${gamePath}assets/audio/win_IdleWin.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "background.idleWinBackground"
                },
                {
                    "name": "win_Number_01",
                    "url": `${gamePath}assets/audio/win_Number_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "level.winAnimBackgroundLevel"
                },
                {
                    "name": "win_Number_02",
                    "url": `${gamePath}assets/audio/win_Number_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "level.winAnimBackgroundLevel"
                },
                {
                    "name": "win_Number_03",
                    "url": `${gamePath}assets/audio/win_Number_01.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "level.winAnimBackgroundLevel"
                },
                {
                    "name": "win_Counter_Start",
                    "url": `${gamePath}assets/audio/win_Counter_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.voice"
                },
                {
                    "name": "win_Counter_Stop",
                    "url": `${gamePath}assets/audio/win_Counter_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.voice"
                }
            ],
            "playlists": [

            ]
        },
        "fonts": {
            "fontFamilies": [
                
                {
                    "name": "winlines_circle_off-export",
                    "type": "bitmap"
                },
                {
                    "name": "winlines_circle_on-export",
                    "type": "bitmap"
                }
            ],
            "defaultFamily": "winlines_circle_off-export",
            "fontSet": [
                {
                    "name": "winlines_circle_on-export",
                    "family": "winlines_circle_on-export",
                    "align": "center",
                    "fontSize": 80,
                    "anchor": [0.5, 0.5],
                    "fontFamily": "winlines_circle_on-export",
                    "isDefault": false
                },
                {
                    "name": "winlines_circle_off-export",
                    "family": "winlines_circle_off-export",
                    "align": "center",
                    "fontSize": 50,
                    "anchor": [0.5, 0.5],
                    "fontFamily": "winlines_circle_off-export",
                    "isDefault": true
                },
                {
                    "name": "font_bigwin-export",
                    "family": "font_bigwin-export",
                    "align": "center",
                    "fontSize": 144,
                    "anchor": [0.5, 0.5],
                    "fontFamily": "font_bigwin-export",
                    "isDefault": true
                }
            ]
        },

        "symbolModel": {
            "enabled": true,
            "animationType": "move",
            "symbolType": "basic",
            "animationDelayStart": 300,
            "animationDelayStop": 300,
            "matrixColumn": 5,
            "matrixRow": 3,
            "symbolSize": {
                "width": 150,
                "height": 150
            },
            "touchZone": {
                "width": 150,
                "height": 150,
                "reels": ["right", "right", "right", "left", "left"],
                "table": "winFactor_table.png",
                "numbers": "page_2_numbers.png",
                "font": "font_factors-export",
                "factors": 3
            },
            "shift" : 55,
            "baseMatrix": {
                "x": [200, 420, 640, 860, 1080],
                "y": [190, 190, 190, 190, 190]
            },
            "staticSymbols": {}
        },
        "symbols": [
            {
                "name" : "symbol_crystal_blue",
                "serverName" : "symbol_crystal_blue",
                "monsterName": "symbol_crystal_blue",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_blue"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_blue_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_green",
                "serverName" : "symbol_crystal_green",
                "monsterName": "symbol_crystal_green",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_green"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_green_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_orange",
                "serverName" : "symbol_crystal_orange",
                "monsterName": "symbol_crystal_orange",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_orange"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_orange_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_purple",
                "serverName" : "symbol_crystal_purple",
                "monsterName": "symbol_crystal_purple",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_purple"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_purple_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_seven",
                "serverName" : "symbol_crystal_seven",
                "monsterName": "symbol_crystal_seven",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_seven"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_seven_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_bar",
                "serverName" : "symbol_crystal_bar",
                "monsterName": "symbol_crystal_bar",
                "index" : 0,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_bar"
                },
                "textureSufix" : ".png",
                "animations" : [
                ],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_bar_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_crystal_yellow",
                "serverName" : "symbol_yellow",
                "monsterName": "symbol_yellow",
                "index" : 1,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_yellow"
                },
                "textureSufix" : ".png",
                "animations" : [],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_yellow_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
            {
                "name" : "symbol_symbol_crystal_wild",
                "serverName" : "symbol_wild",
                "monsterName": "symbol_wild",
                "index" : 1,
                "type" : "normal",
                "textures" : {
                    "main" : "crystal_wild"
                },
                "textureSufix" : ".png",
                "animations" : [],
                "layerId" : 0,
                "scale" : 1,
                "anims": {
                    "win": {
                        "name": "symbol_crystal_wild_000",
                        "start": 0,
                        "end": 17
                    }
                }
            },
        ],

        "flash": {

        },
        "info": {
            "enabled": false,
            "pages": 2
        },
        "c": {

        },
        "s": {

        },
        "h": {
            "sprites": [
                gamePath + "assets/counter/counter.json",
                gamePath + "assets/logo.json",
                gamePath + "assets/symbols/symbols.json",
                gamePath + "assets/symbols/symbol_crystal_bar.json",
                gamePath + "assets/symbols/symbol_crystal_blue.json",
                gamePath + "assets/symbols/symbol_crystal_orange.json",
                gamePath + "assets/symbols/symbol_crystal_yellow.json",
                gamePath + "assets/symbols/symbol_crystal_green.json",
                gamePath + "assets/symbols/symbol_crystal_seven.json",
                gamePath + "assets/symbols/symbol_crystal_purple.json",
                gamePath + "assets/symbols/symbol_crystal_wild.json",
                gamePath + "assets/fonts/winlines_circle_off-export.xml",
                gamePath + "assets/fonts/winlines_circle_on-export.xml",
                gamePath + "assets/fonts/font_factors-export.xml",
                gamePath + "assets/fonts/font_bigwin-export.xml",
                gamePath + "assets/fonts/font_win-export.xml",
                gamePath + "assets/fonts/idle_win-export.xml",
                gamePath + "assets/other.json",
                gamePath + "assets/info/info.json",
                gamePath + "assets/info/info_wild.json",
                gamePath + "assets/reels/reels.json"
            ],
            "assets": [
                {
                    "name": "bigwin",
                    "url": gamePath + "assets/bigwin/bigwin.png",
                    "type": "Image",
                    "set": {
                        "x": 0,
                        "y": 0,
                        "width": 698,
                        "height": 159
                    }
                },
                {
                    "name": "megawin",
                    "url": gamePath + "assets/bigwin/megawin.png",
                    "type": "Image",
                    "set": {
                        "x": 0,
                        "y": 0,
                        "width": 902,
                        "height": 161
                    }
                },
                {
                    "name": "supermegawin",
                    "url": gamePath + "assets/bigwin/supermegawin.png",
                    "type": "Image",
                    "set": {
                        "x": 0,
                        "y": 0,
                        "width": 902,
                        "height": 318
                    }
                },
                {
                    "name": "bigwin_mask_2",
                    "url": gamePath + "assets/bigwin/bigwin_mask_2.png",
                    "type": "Image",
                    "set": {
                        "x": 0,
                        "y": 0,
                        "width": 1280,
                        "height": 720
                    }
                },
                {
                    "name": "background_reels",
                    "url": gamePath + "assets/reels/reels_background.png",
                    "type": "Image",
                    "set": {
                        "x": 0,
                        "y": 0,
                        "width": 1280,
                        "height": 720
                    }
                }
			]
        },
        "lines": [

        ],
        "grelems": [
            {
                "name": "background_reels",
                "frame": "background_reels",
                "layer": "background",
                "sufix": "",
                "layerId": 0,
                "type": "Image",
                "defaultAddToLayer": true,
                "alpha": 1,
                "sourceFormat": "image",
                "set": {
                    "x": 1,
                    "y": 1
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
			}
        ]
    }
};

export default gameset;
